<template>
  <v-card>
    <v-card-title>退掛項目</v-card-title>
    <v-card-text class="text-body-1">
      <div>日期：{{ person.日期 }}</div>
      <div>地點：{{ person.地點 }}</div>
      <div>姓名：{{ person.姓名 }}</div>
      <div>身分證字號：{{ person.身分證字號 }}</div>
      <div>可退掛項目：</div>
      <div v-for="(value, item) of person.篩檢項目" v-if="value">
        <v-checkbox
          v-model="returnItem"
          :value="item"
          color="error"
          class="mt-1"
          :label="`${item}${today ? '' : '（僅可退掛今日場次）'}`"
          hide-details
          :disabled="!today"
        ></v-checkbox>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="error" @click="$emit('close')">關閉</v-btn>
      <v-btn text color="primary" @click="handleReturn">退掛</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "returnDialog",
  props: ["id", "reservationId"],
  data: () => ({
    person: {},
    returnItem: [],
  }),
  async created() {
    await this.getReservation();
  },
  computed: {
    today() {
      // return false;
      return dayjs().format("YYYY-MM-DD") == this.person.日期;
    },
  },
  methods: {
    async getReservation() {
      this.person = (
        await this.axios.get(
          `/dashboard/person/reservation/${this.reservationId}`
        )
      ).data;
    },
    async handleReturn() {
      if (confirm(`確認退掛${this.returnItem.join("、")}篩檢項目?`)) {
        await this.axios.post(`/dashboard/person/return`, {
          身分證字號: this.id,
          reservationId: this.reservationId,
          退掛項目: this.returnItem,
        });
        this.$toast.success("退掛完成!");
        this.$emit("close");
        this.$emit("loadList");
      }
    },
  },
};
</script>

<style></style>
